export default {"id":"icon-folder-open-solid"}